import {
  marketplaceFulfillmentStatusLabel,
  type MarketplaceFulfillmentStatus,
} from "@nexus/contracts";
import type { TFunction } from "i18next";

import type { MarketplaceFulfillmentViewer } from "./fulfillment-badge-variant";

export function getFulfillmentStatusLabel(
  t: TFunction,
  status: MarketplaceFulfillmentStatus,
  _viewer: MarketplaceFulfillmentViewer,
): string {
  return t(
    `marketplace.orders.fulfillment.${status}`,
    marketplaceFulfillmentStatusLabel(status),
  );
}
